import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Inbox, Phone, MessageCircle, Mail, RefreshCw, AlertTriangle, ArrowRight } from "lucide-react";

/**
 * V1.30.1 · Widget compacto de la Bandeja ANA para el dashboard "inicio".
 * Muestra los contadores clave + botón "Ir a Bandeja ANA".
 */
export default function AnaInboxWidget({ onNavigate }) {
  const [stats, setStats] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/ana/inbox/quick-stats?scope=mine");
      setStats(data);
    } catch (err) { /* silent */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, [load]);

  if (!stats) return null;

  return (
    <div className="rounded-xl border border-neutral-200 bg-white p-3" data-testid="ana-inbox-widget">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Inbox className="h-4 w-4 text-orange-600" />
          <h3 className="font-semibold text-sm">Bandeja ANA</h3>
          <span className="text-[10px] text-neutral-500">mis tareas</span>
        </div>
        <button
          type="button"
          onClick={() => onNavigate && onNavigate("ana_workspace")}
          data-testid="ana-inbox-widget-go"
          className="text-[11px] font-semibold text-orange-700 hover:text-orange-900 inline-flex items-center gap-1"
        >
          Ir a Bandeja <ArrowRight className="h-3 w-3" />
        </button>
      </div>
      <div className="grid grid-cols-4 gap-2">
        <Kpi Icon={AlertTriangle} label="Vencidas" value={stats.overdue} color="red" testid="widget-overdue" />
        <Kpi Icon={Phone} label="Llamadas" value={stats.calls} color="blue" testid="widget-calls" />
        <Kpi Icon={MessageCircle} label="WhatsApp" value={stats.whatsapps} color="emerald" testid="widget-whatsapps" />
        <Kpi Icon={RefreshCw} label="Seguimientos" value={stats.followups} color="amber" testid="widget-followups" />
      </div>
    </div>
  );
}

function Kpi({ Icon, label, value, color, testid }) {
  const colorMap = {
    red: "bg-red-50 text-red-800",
    blue: "bg-blue-50 text-blue-800",
    emerald: "bg-emerald-50 text-emerald-800",
    amber: "bg-amber-50 text-amber-800",
  };
  return (
    <div data-testid={testid} className={"rounded-lg p-2 " + (colorMap[color] || colorMap.blue)}>
      <div className="flex items-center gap-1 text-[9px] uppercase font-semibold opacity-80">
        <Icon className="h-2.5 w-2.5" /> {label}
      </div>
      <div className="text-lg font-bold">{value}</div>
    </div>
  );
}
